import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { classNames } from '../tools/helpers';
import { getSite } from '../tools/fetcher';
import Button from "./Button";

export default function Hero({ className }) {
    const { data } = useQuery({
        queryKey: ['sites'],
        queryFn: getSite,
    });

    return (
        <div className={classNames('flex gap-[64px] items-center z-10', className)}>
            <div className={'264px sm:max-w-[516px] space-y-2 sm:space-y-4 z-10'}>
                <p
                    className={
                        'font-bold text-[32px] leading-[36px] text-white sm:text-[64px] sm:leading-[68px]'
                    }
                >
                    {data?.hero?.title}
                </p>
                <p className={'leading-7 max-w-[456px] text-white'}>
                    {data?.hero?.description}
                </p>
                <div className={'flex items-center'}>
                    <Button
                        type="a"
                        href={data?.hero_button?.link_url}
                        className={
                            'bg-gradient-to-r from-primary-black-101 to-primary-black-102 sm:px-8 !sm:h-[60px]'
                        }
                        target="_blank"
                    >
                        {data?.hero_button?.title}
                    </Button>
                </div>
            </div>
        </div>
    );
}
